<template>
  <div>
    <div class="mb-3">
      <li
        style="
          text-align: start;
          display: block;
          color: #000000;
          font-family: dfyuanstd-w5, dfyuanstd-w3;
          font-size: 1rem;
        "
      >
        生產重量
      </li>
      <runcardTable
        :workID="orderManagementDetailData.workCode"
        :runcardItem="
          orderManagementDetailData.sourceData[userSelectCode].runcardItem
        "
        :reason="orderManagementDetailData.sourceData[userSelectCode].reason"
        :modStatus="modStatus"
      />
    </div>
    <div class="mb-3">
      <li
        style="
          text-align: start;
          display: block;
          color: #000000;
          font-family: dfyuanstd-w5, dfyuanstd-w3;
          font-size: 1rem;
        "
      >
        總生產時間
      </li>
      <totalProduceTable
        :processID="orderManagementDetailData.operID"
        :totalProduceTimeItem="
          orderManagementDetailData.sourceData[userSelectCode].totalProduceTimeItem
        "
        :reason="orderManagementDetailData.sourceData[userSelectCode].reason"
        :modStatus="modStatus"
      />
    </div>
  </div>
</template>
  
<script>
import runcardTable from "@/components/orderManagement/orderDataTemplate/table/runcardTable.vue";
import totalProduceTable from "@/components/orderManagement/orderDataTemplate/table/totalProduceTable.vue";
import { inject } from "vue";
export default {
  props: {
    userSelectCode: {
      type: Number,
      default: 0,
    },
    modStatus: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    runcardTable,
    totalProduceTable,
  },
  setup() {
    const orderManagementDetailData = inject("orderManagementDetailData");
    return {
      orderManagementDetailData,
    };
  },
};
</script>

<style scoped></style>